import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledNotFoundContent } from './styles/StyledNotFoundContent';


class NotFoundContent extends Component {
  constructor(props) {
    super(props);

    this.handleOnClickBtn = this.handleOnClickBtn.bind(this);
  }

  handleOnClickBtn() {
    this.props.router.push('/');
  }

  render() {
    return (
      <StyledNotFoundContent>
      <div className="notFound-container">
        <div className="notFound-content">
          <div className="notFound-404">
            <div className="notFound-table">
              <div className="notFound-table-cell">
                404
              </div>
            </div>
          </div>
          <div className="notFound-title">
            Stránka nebyla nalezena.
          </div> 
          <div className="notFound-btn disable-select"
            onClick={this.handleOnClickBtn}
          >
            <span className="notFound-arrow">
              <i className="fa fa-angle-left" aria-hidden="true"></i>
            </span>
            <span className="notFound-text">
              Rezervační systém
            </span>
          </div>
        </div>  
      </div>      
      </StyledNotFoundContent>
    );
  }
}


NotFoundContent.propTypes = {
  router: PropTypes.any,
};


export default NotFoundContent;


// WEBPACK FOOTER //
// ./src/components/NotFoundContent/NotFoundContent.js